import { Input, Form } from "antd";
import type { Rule } from "antd/es/form";
import { CURRENCIES_FILED } from "../constants/currencies.constant";
import { numberValidation } from "../utils/ValidationRules";
const AmountField = ({
  name,
  currency,
  extraRules = [],
  maxAmount,
}: {
  name: string;
  currency?: string;
  extraRules?: Rule[];
  /** When set, adds a rule that amount must not exceed this value (decimal-safe). */
  maxAmount?: number;
}) => {
  const maxRules: Rule[] =
    maxAmount !== undefined
      ? [
          {
            validator: (_, value) => {
              if (value === undefined || value === null || value === "") {
                return Promise.resolve();
              }
              const cleaned = String(value).replace(/,/g, "").trim();
              const num = parseFloat(cleaned);
              if (!Number.isFinite(num)) {
                return Promise.reject("Enter a valid amount");
              }
              if (num <= 0) {
                return Promise.reject("Amount must be greater than zero");
              }
              if (num > maxAmount) {
                return Promise.reject(
                  `Amount cannot exceed available payout (${maxAmount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })})`,
                );
              }
              return Promise.resolve();
            },
          },
        ]
      : [];

  return (
    <Form.Item
      name={name}
      label="Amount"
      className="w-full"
      rules={[
        ...numberValidation(
          "Amount",
          "",
          true,
          false,
          500000,
          "Amount cannot exceed 5,00,000",
        ),
        ...maxRules,
        ...extraRules,
      ]}
    >
      <Input
        placeholder="Enter amount"
        style={{ width: "100%" }}
        prefix={
          CURRENCIES_FILED[currency as keyof typeof CURRENCIES_FILED]?.prefix
            ? CURRENCIES_FILED[currency as keyof typeof CURRENCIES_FILED]
                ?.symbol
            : ""
        }
        suffix={
          CURRENCIES_FILED[currency as keyof typeof CURRENCIES_FILED]?.postfix
            ? CURRENCIES_FILED[currency as keyof typeof CURRENCIES_FILED]
                ?.symbol
            : ""
        }
      />
    </Form.Item>
  );
};

export default AmountField;
